import { UserModel } from './user.model';
import { AuthResponseModel } from './auth.model';
import {BaseModel} from '../../shared/entities/base.model';

export class RegisterRequestModel extends BaseModel{
    user: UserRegistrationModel;
    company: CompanyRequestModel;
    finish: FinishRequestModel;
    files: FormData;
}

export class UserRegistrationModel extends BaseModel {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
    entityType: string;
}

export class CompanyRequestModel extends BaseModel {
    name: string;
    uniqueRegistrationCode: string;
    nrRegCom: string;
}

export class FinishRequestModel extends BaseModel {
    terms: boolean;
    files: FormData;
}
